export const capitalizeWord = (word?: string) => {
	if (!word) {
		return null;
	}

	return `${word[0].toUpperCase()}${word.slice(1, word.length)}`;
};
